import { FunctionComponent } from 'react';

import SatNoteFormQuestionsIntroduced from './Introduced';
import SatNoteFormQuestionsStandard from './Standard';
import SatNoteFormQuestionsSupplyOnly from './SupplyOnly';

export interface SatNoteFormQuestionsProps {
  isIntroduced?: boolean;
  isSupplyOnly?: boolean;
}

const SatNoteFormQuestions: FunctionComponent<SatNoteFormQuestionsProps> = ({
  isIntroduced = false,
  isSupplyOnly = false,
}) => (
  <>
    <div className="font-bold text-14-22-em text-neutral-700 mb-6">
      Please answer the below questions
    </div>
    {isIntroduced && <SatNoteFormQuestionsIntroduced />}
    {isSupplyOnly && <SatNoteFormQuestionsSupplyOnly />}
    {!isSupplyOnly && !isIntroduced && <SatNoteFormQuestionsStandard />}
  </>
);

export default SatNoteFormQuestions;
